var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-badge',_vm._b({attrs:{"overflowCount":_vm.options.limit,"offset":_vm.options.offset}},'a-badge',_vm.options,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }